import { render, staticRenderFns } from "./FeaturedPostTextMod.vue?vue&type=template&id=4141374e"
import script from "./FeaturedPostTextMod.vue?vue&type=script&lang=js"
export * from "./FeaturedPostTextMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports